/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { selectIsAuth } from 'store/auth/authSlice';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import {
  dropStartTags,
  fetchStartTags,
  selectIsPending,
  selectStartTags,
} from 'store/tagsSlice';
import { tagsFromString, tagsToString } from 'utils/utils';
import some from 'lodash-es/some';
import isEmpty from 'lodash-es/isEmpty';
import size from 'lodash-es/size';
import { TagsResponse } from 'store/types';

export const useStartTags = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const isAuth = useAppSelector(selectIsAuth);
  const isPending = useAppSelector(selectIsPending).start;
  const startTags = useAppSelector(selectStartTags);
  const [searchParams] = useSearchParams();
  const searchTags = searchParams.get('tags') || '';

  useEffect(() => {
    const _fetchStartTags = async () => {
      const result = await dispatch(fetchStartTags(searchTags));

      // Нужно сразу после ответа удалить из строки поиска несуществующие теги
      // и перейти на новую страницу, чтобы избежать зацикливания
      if (result.meta.requestStatus === 'fulfilled') {
        const tags = (result.payload as TagsResponse).data;
        const newSearchTags = tagsToString(tags);
        searchParams.set('tags', newSearchTags);

        navigate(`${window.location.pathname}?${searchParams.toString()}`, {
          replace: true,
        });
      }
    };

    if (isAuth && !isPending) {
      const tagsFromSearch = tagsFromString(searchTags);

      const isNotEquals =
        size(tagsFromSearch) !== size(startTags) ||
        some(tagsFromSearch, (tag) => {
          return startTags[tag.name] === undefined;
        });

      // Обновить начальные теги нужно только в случае их изменения в строке поиска
      if (isNotEquals && isAuth && !isPending) {
        // При этом, если теги из строки удалились, нет необходимости слать запрос для валидации
        if (isEmpty(tagsFromSearch)) {
          dispatch(dropStartTags());
          return;
        }

        _fetchStartTags();
      }
    }
  }, [searchTags, isAuth, isPending, startTags]);

  return startTags;
};
